import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-kt-cogs-detail-modal',
  templateUrl: './kt-cogs-detail-modal.component.html',
  standalone: false,
})
export class KtCogsDetailModalComponent {
  constructor(
    public dialogRef: MatDialogRef<KtCogsDetailModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { id: number },
  ) {}

  public closeDialog(): void {
    this.dialogRef.close();
  }
}
